import { Button } from '@mui/material';
import { styled } from '@mui/system';
import theme from '../../assets/theme'; // Import theme

const CustomButton = styled(Button)(({ size = 'medium', variant = 'primaryColor' }) => {
  const style = theme.buttons[size]?.[variant] || {};
  return {
    backgroundColor: style.backgroundColor,
    borderRadius:theme.borderRadius.medium,
    border: style.border,
    color: style.color,
    opacity: style.opacity,
    fontFamily: 'Nunito Sans',
    fontWeight: 700,
    textTransform: 'none',
    padding: '8px 16px', // Adjust based on your UI preference
    minWidth: 64, // Prevent button from collapsing
    height:40,
  };
});

export default CustomButton;
